export default "__VITE_ASSET__Z9MK0x9$__"